<template>
    <a class="CampaignCard list-group-item p-0 mb-4 text-sm">
        <div class="CampaignCard__row">
            <div class="CampaignCard__cover">
                <CampaignImage :campaign="campaign" />
            </div>
            <div class="CampaignCard__content">
                <slot></slot>
            </div>
        </div>
    </a>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/utilities';

.CampaignCard {
    .b-rad-lg !important;
}

.CampaignCard__row {
    @media (min-width: @screen-sm-min) {
        display: flex;
    }
}

.CampaignCard__cover {
    flex: 1;
}

.CampaignCard__content {
    flex: 2;
    position: relative;
}

.CampaignCard__content,
.CampaignCard__content__overlay {
    padding: 20px;

    @media (min-width: @screen-sm-min) {
        padding-left: 40px;
    }
}

.CampaignCard .CampaignImage {
    @media (max-width: @screen-xs-max) {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }
    @media (min-width: @screen-sm-min) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
}

.CampaignCard__content__inner.--has-overlay {
    filter: blur(5px);
}

.CampaignCard__content__overlay {
    @apply absolute inset-0 flex flex-wrap content-center justify-center text-center rounded-lg text-white;

    background-color: rgba(46, 50, 53, 0.7);

    h3 {
        color: white;
        line-height: 175%;

        @media (max-width: @screen-xs-max) {
            font-size: 17px;
        }
    }

    .cool-emoji {
        font-size: 40px;
    }

    @media (max-width: @screen-xs-max) {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }
    @media (min-width: @screen-sm-min) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
}
</style>

<script type="text/babel">
import CampaignImage from 'dashboard-js/components/campaigns/CampaignImage'
export default {
    components: { CampaignImage },

    props: ['campaign'],

    computed: {
        backgroundImage() {
            return {
                'background-image': 'url(' + this.campaign.image_url + ')',
            }
        },
    },
}
</script>
